import { asyncRouterMap, constantRouterMap } from '@/router/index'

/**
 * 判断用户是否拥有此菜单
 * @param menus
 * @param route
 */
function hasPermission(menus, route) {
    for (var i = 0; i < menus.length; i++) {
        if (menus[i].code == route.code || route.code == '') {
            return true;
        }
    }
    return false;
}

/**
 * 递归过滤异步路由表，返回符合用户菜单权限的路由表
 * @param asyncRouterMap
 * @param menus
 */
function filterAsyncRouter(asyncRouterMap, menus) {
    const accessedRouters = asyncRouterMap.filter(route => {
        //filter,js语法里数组的过滤筛选方法
        if (hasPermission(menus, route)) {
            if (route.children && route.children.length) {
                //如果这个路由下面还有下一级的话,就递归调用
                route.children = filterAsyncRouter(route.children, menus)
                    //如果过滤一圈后,没有子元素了,这个父级菜单就也不显示了
                return (route.children && route.children.length)
            }
            return true
        }
        return false
    })
    return accessedRouters
}

const permission = {
    state: {
        routers: constantRouterMap, //本用户所有的路由,包括了固定的路由和下面的addRouters
        addRouters: [], //本用户的角色赋予的新增的动态路由
        menus: [] //菜单集合
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers
            state.routers = constantRouterMap.concat(routers) //将固定路由和新增路由进行合并, 成为本用户最终的全部路由信息
        },
        SET_MENUS: (state, menus) => {
            state.menus = menus
        }
    },
    actions: {
        GenerateRoutes({ commit }, param) {
            //生成路由
            return new Promise(resolve => {
                //执行设置菜单
                commit('SET_MENUS', param.menus)
                    //声明 该角色可用的路由
                let accessedRouters
                if (param.isAdmin === '1') {
                    //如果角色里包含'管理员',那么所有的路由都可以用
                    //其实管理员也拥有全部菜单,这里主要是利用角色判断,节省加载时间
                    accessedRouters = asyncRouterMap
                } else {
                    //否则需要通过以下方法来筛选出本角色可用的路由
                    const menus = param.menus;
                    // accessedRouters = filterAsyncRouter(asyncRouterMap, menus)
                    // console.log(accessedRouters)
                    accessedRouters = asyncRouterMap
                }
                //执行设置路由的方法
                commit('SET_ROUTERS', accessedRouters)
                resolve()
            })
        }
    }
}
export default permission


// WEBPACK FOOTER //
// ./src/store/modules/permission.js